'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = require('redux');

var _linksoft = require('linksoft');

var _linksoft2 = _interopRequireDefault(_linksoft);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    var reducers = _linksoft2.default.reducers.get();
    return (0, _redux.combineReducers)(reducers);
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/reducers.js
// module id = 576
// module chunks = 0 1